var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61 0C14.9187 0 19.22 4.30125 19.22 9.61C19.22 14.9187 14.9187 19.22 9.61 19.22C4.30125 19.22 0 14.9187 0 9.61C0 4.30125 4.30125 0 9.61 0ZM5.115 11.315H9.61V14.0624C9.61 14.477 10.1138 14.6862 10.4044 14.3918L14.8335 9.93937C15.0156 9.75725 15.0156 9.46663 14.8335 9.2845L10.4044 4.82825C10.1099 4.53375 9.61 4.743 9.61 5.15763V7.905H5.115C4.85925 7.905 4.65 8.11425 4.65 8.37V10.85C4.65 11.1058 4.85925 11.315 5.115 11.315Z",
    fill: "url(#paint0_linear_771_8300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_771_8300",
    x1: 9.61,
    y1: 0,
    x2: 9.61,
    y2: 27.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C21818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04A4A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.b9996dba01e79a4488f8168c7cc7d5c3.svg";
export { ForwardRef as ReactComponent };